export const formatToCurrency = (numberFixed, includeCurrencySymbol) => {
  let result;

  if (numberFixed.endsWith('00')) {
    result = numberFixed.toString().replace('.00', '');
  } else {
    result = numberFixed;
  }

  if (includeCurrencySymbol) {
    result = `$${result}`;
  }

  return result;
};
